// This is a modal for Adminaccountsone

import styled from "@emotion/styled";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { Button as AIMEButton } from "tot-loft-component-library";
import * as PRTNR from "./prtnr";
import {
  addAdminaccounts,
  updateAdminaccounts,
} from "./redux/slices/AdminaccountsThunks";

export default function ModalAdminaccountsone({
  onClose,
  active = { email: "", password: "" },
  type = "Add",
}) {
  const [email, setEmail] = useState(active?.email);
  const [password, setPassword] = useState(active?.password);
  const dispatch = useDispatch();

  const addAdmin = async () => {
    if (type == "Edit") {
      const data = {
        _id: active?._id,
        email: email,
        password: password,
      };
      await dispatch(updateAdminaccounts(data));
    } else {
      const data = {
        email: email,
        password: password,
        type: "Admin",
      };
      await dispatch(addAdminaccounts(data));
    }
    onClose();
  };

  return (
    <RootWrapperModalAdminaccountsone>
      <Wrapper>
        <Sector>
          <Left>
            <Frame58>
              <Frame1391>
                <AddAnAccount>
                  {type == "Edit" ? "Edit" : "Add"} an Account
                </AddAnAccount>
              </Frame1391>
              <Frame1391>
                <PRTNR.Input
                  label="Email address"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />
              </Frame1391>
              <Frame1391>
                <PRTNR.Input
                  label="Password"
                  type="password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                />
              </Frame1391>

              <Frame1417>
                <AIMEButton
                  size="small"
                  onClick={() => {
                    setEmail("");
                    setPassword("");
                  }}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    flex: "none",
                    borderRadius: "999px",
                    background: "rgb(241, 245, 249)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    boxSizing: "border-box",
                    padding: "16px 32px",
                  }}
                >
                  <span
                    style={{
                      color: "rgb(33, 37, 67)",
                      textOverflow: "ellipsis",
                      fontSize: "16px",
                      fontFamily: "Montserrat, sans-serif",
                      fontWeight: "600",
                      lineHeight: "110%",
                      textAlign: "left",
                    }}
                  >
                    Cancel
                  </span>
                </AIMEButton>

                <AIMEButton
                  size="small"
                  onClick={() => {
                    addAdmin();
                  }}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    flex: "none",
                    gap: "10px",
                    borderRadius: "48px",
                    width: "240px",
                    background: "rgb(97, 98, 197)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    boxSizing: "border-box",
                    padding: "16px 32px",
                  }}
                >
                  <span
                    style={{
                      color: "white",
                      textOverflow: "ellipsis",
                      fontSize: "16px",
                      fontFamily: "Montserrat, sans-serif",
                      fontWeight: "600",
                      lineHeight: "110%",
                      textAlign: "left",
                    }}
                  >
                    Save
                  </span>
                </AIMEButton>
              </Frame1417>
            </Frame58>
          </Left>
        </Sector>
        <Frame1392
          src="https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/ec3cdf87-031c-4183-8a15-9212cc9bc411"
          alt="icon"
        />
      </Wrapper>
    </RootWrapperModalAdminaccountsone>
  );
}

const RootWrapperModalAdminaccountsone = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  box-sizing: border-box;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  border-radius: 32px;
  width: 534px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
`;

const Sector = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: 1;
  gap: 24px;
  width: 486px;
  box-sizing: border-box;
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  width: 486px;
  box-sizing: border-box;
`;

const Frame58 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1391 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const AddAnAccount = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 30px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1417 = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;


const Frame1392 = styled.img`
  width: 32px;
  height: 32px;
  object-fit: cover;
`;
